module.exports = __webpack_public_path__ + "static/media/looza-orange.cdfd7e44.jpg";